import useStore from './_store';
import { mapState as rootMapState } from 'pinia';
import { mapState, mapActions } from '@/store/helpers';
import { usePageStore } from '@/store';
import util from '../../common/util';
import { formats } from '../../common/format';

import { mapAsyncData } from '../../plugins/asyncData';
import { asyncData } from './async-data';

import { SET_INFO, SET_LISTING } from './_store/types';
import { buildUrl } from "@/router/index.js";

export default {
    _getUseStore: useStore,
    i18next: {
        ns: 'md-house-listing'
    },
    data: function() {
        return {
            showSubTitle: true,
            centerClass: ''
        };
    },
    asyncData: mapAsyncData(asyncData),
    methods: {

        ...mapActions({
            "setInfo": SET_INFO,
            "setListing": SET_LISTING
        }),
        
        getData() {
            if (util.inCms) {
                var detail = this.listingDetail && this.listingDetail.info;
                if (this.forMoreData) {
                    this.setInfo({
                        dataType: this.pageLocation.query.forMoreType || 'hot'
                    });
                    if (detail) {
                        this.setInfo({
                            baseUrl: detail.detailUrl,
                            baseListingAddr: `${detail.streetAddress}, ${detail.cityAddress}`
                        });
                    }
                } else {
                    this.setInfo({ dataType: this.dataType || 'recommend' });
                    var extParam = {
                        dataType: this.dataType || 'recommend',

                    }

                    if (this.dataType === 'recommend' && detail) {
                        extParam['detailId'] = detail.id
                    }
                    if (this.isSold) {
                        extParam['isSold'] = true;
                    }
                    
                    this.setInfo({
                        moreLink: buildUrl({ name: 'house-listing',
                            query: extParam })
                    });
                }
                var ps;
                const needMock = util.inCmsPageEditor && !this.page.isLandingPage;
                switch (this.dataType) {
                case 'hot':
                    ps = needMock
                        ? import(
                            /* webpackChunkName: "house_listing_mock"*/ './mock-data'
                        ).then(r => r.default.hot)
                        : this.axiosIns.get('/api-site/listing/hot-listings', {
                            params: { pageSize: this.size || 3 }
                        });
                    break;
                case 'recommend':
                    ps = needMock
                        ? import(
                            /* webpackChunkName: "house_listing_mock"*/ './mock-data'
                        ).then(r => r.default.hot)
                        : this.axiosIns.get('/api-site/listing/recommended-listings', {
                            params: {
                                pageSize: this.size || 3,
                                detailId: (detail && detail.id) || ''
                            }
                        });
                    break;
                default:
                    ps = Promise.resolve({ data: { listings: [] } });
                    break;
                }
                ps.then(res => {
                    console.log(res);
                    const listing =
                        (res.data && res.data.listings) || res.listings || [];
                    this.setListing(listing);
                });
            }
        }
    },
    watch: {
        dataType: function() {
            this.getData();
        },
        size: function() {
            this.getData();
        }
    },
    computed: {

        ...rootMapState(usePageStore, {
            "page": store => store.page || {},
            "currencySymbol": store => store.currency.symbol
        }),

        ...mapState({
            "listing": "listing",
            "moreLink": "moreLink",
            "baseUrl": "baseUrl",
            "baseListingAddr": "baseListingAddr",
            "dataType": "dataType",
            "forMoreData": "forMoreData"
        }),
        
        
        isMobileSize() {
            return this.platform.isMobile;
        },
        // wordPressWidget  temporarily in wordPress hide in more， display if required   use wordPressWidget judge
        wordPressSSR({ page }) {
            return page.wordPressSSR;
        },
        titleContent() {
            if (this.title) {
                return this.title;
            }
            if (this.dataType === 'hot') {
                return this.$t('md-house-listing.hotListings');
            }
            if (this.dataType === 'recommend') {
                return this.$t('md-house-listing.similarHomesForSale');
            }
            return '';

            // return this.title || this.dataType === 'hot'
            //     ? this.$t('md-house-listing.hotListings')
            //     : this.dataType === 'recommend'
            //     ? this.$t('md-house-listing.similarHomesForSale')
            //     : undefined;
        },
        exist() {
            return this.listing && this.listing.length > 0;
        },
        subTitle({ page, isSold }) {
            const info = (this.listingDetail && this.listingDetail.info) || {};
            const property =
                info.propertyType || info.propertyTypePrimary || 'Propertie';
            const priceKey = isSold ? 'soldPrice' : 'price';
            const addr = [info.city, info.state || info.zipCode]
                .filter(Boolean)
                .join(',');
            return info[priceKey]
                ? this.$t('md-house-listing.checkForSimilarPropertyAtPrice', {
                    property,
                    price:
                          this.currencySymbol + formats.number(info[priceKey]),
                    addr
                })
                : this.$t('md-house-listing.checkForSimilarProperty', {
                    property,
                    addr
                });
        },
        isSold({ listingDetail, page }) {
            var detail = listingDetail?.info;
            var isSold = /sold/.test(page.pageKey);
            if (detail && detail.listingStatus == "Sold") {
                isSold = true;
            }
            return isSold;
        }
    }
};
